import { useCallback, useState } from 'react';

function lees(sleutel: string): unknown {
  try {
    const tekst = window.localStorage.getItem(sleutel);
    return tekst === null ? undefined : JSON.parse(tekst);
  } catch {
    return undefined;
  }
}

/**
 * Een voorkeur die per browser bewaard blijft, zoals de kolommen van een lijst. Lukt bewaren niet, bijvoorbeeld in
 * een privévenster, dan werkt de voorkeur alleen tot de pagina sluit.
 * @param sleutel De naam waaronder de voorkeur in localStorage staat.
 * @param maakGeldig Maakt van wat er bewaard was, of `undefined`, een geldige waarde.
 * @returns De huidige waarde en een functie om hem te wijzigen en te bewaren.
 */
export function useBewaardeWaarde<T>(sleutel: string, maakGeldig: (bewaard: unknown) => T): [T, (waarde: T) => void] {
  const [waarde, setWaarde] = useState<T>(() => maakGeldig(lees(sleutel)));
  const zet = useCallback(
    (nieuw: T) => {
      setWaarde(nieuw);
      try {
        window.localStorage.setItem(sleutel, JSON.stringify(nieuw));
      } catch {
        // Niet te bewaren; de keuze geldt dan alleen nu.
      }
    },
    [sleutel],
  );
  return [waarde, zet];
}
